<template>
  <div class="content">
    <div class="bodycontent">
      <el-form
        :model="formData"
        ref="formData"
        label-width="180px"
        :rules="rules"
      >
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="formData.name" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input
            type="textarea"
            v-model="formData.des"
            class="input_box"
            :rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色权限">
          <el-checkbox-group v-model="selected" v-if="false">
            <el-checkbox
              v-for="item in selectionList"
              :key="item.id"
              :label="item.id"
              class="selection"
              >{{ item.title }}</el-checkbox
            >
          </el-checkbox-group>
          <el-tree
            :data="treeData"
            show-checkbox
            node-key="id"
            default-expand-all
            ref="tree"
          >
          </el-tree>
        </el-form-item>
        <el-form-item label="后台功能模块">
          <el-checkbox-group v-model="pageRouterData">
            <el-checkbox
              :label="item.path"
              v-for="(item, index) in pageRouter"
              :key="index"
            >
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="bottom_btn">
        <el-button type="primary" @click="save">提交</el-button>
        <el-button @click="goback()">返回列表</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { roleAdd, roleDetail, roleEdit, ruleList } from "@/api/employee";

export default {
  components: {},
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      formData: {},
      if_add: true, //是否是新增
      loading: false, //页面loading
      rule_options: [], //权限选项数据
      selectionList: [], //可选项列表
      selected: [], //已选择列表
      treeData: [], //树形结构

      rules: {
        name: [{ required: true, message: "请输入角色名称", trigger: "blur" }]
      },
      pageRouterData: [],
      pageRouter: [
        {
          path: "oilsList",
          name: "消费订单"
        },
        {
          path: "oilsListNow",
          name: "当前班次"
        },
        {
          path: "voucherList",
          name: "充值订单"
        },
        {
          path: "ordinaryList",
          name: "普通订单"
        },
        {
          path: "shellIntegral",
          name: "积分商城订单"
        },
        {
          path: "getMoney",
          name: "收银台"
        },
        {
          path: "recharge",
          name: "快速充值"
        },
        {
          path: "integral",
          name: "会员积分"
        },
        {
          path: "scanVerification",
          name: "现金待确认"
        },
        {
          path: "changeDuty",
          name: "交班"
        },
        {
          path: "userList",
          name: "客户列表"
        },
        {
          path: "refuel",
          name: "改油价"
        }
      ]
    };
  },
  methods: {
    init() {
      // this.loading = true;
      ruleList({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.rule_options = res.data;
          console.log(this.rule_options);
          this.rule_options.forEach(item => {
            var treeItem = {
              id: item.id,
              label: item.title
            };
            if (item.list !== undefined) {
              console.log(item.list);
              var child = [];
              for (let i in item.list) {
                this.selectionList.push({
                  id: item.list[i].id,
                  title: item.list[i].title
                }); //属性
                // 新增三级
                let obj = {
                  id: item.list[i].id,
                  label: item.list[i].title,
                  children: []
                };
                if (item.list[i].list !== undefined) {
                  for (let j in item.list[i].list) {
                    obj.children.push({
                      id: item.list[i].list[j].id,
                      label: item.list[i].list[j].title
                    });
                  }
                }
                child.push(obj);
              }
              treeItem.children = child;
              child = [];
            } else {
              this.selectionList.push({ id: item.id, title: item.title });
            }
            this.treeData.push(treeItem);
          });
          console.log(this.selectionList);
          console.log(this.treeData);
          this.loading = false;
          this.initForm();
        }
      });
    },
    initForm() {
      if (this.$route.query.sid) {
        this.if_add = false;
        this.loading = true;
        var data = {
          token: this.token,
          app_id: this.app_id,
          id: this.$route.query.sid
        };
        roleDetail(data).then(res => {
          var edit = Object.assign({}, res.data);
          this.formData = {
            id: edit.id,
            name: edit.name,
            des: edit.des
          };
          edit.rule_ids.split(",").forEach(item => {
            this.selected.push(Number(item));
          });
          console.log(this.selected);
          this.selected.forEach(id => {
            this.$refs.tree.setChecked(id, true, false);
          });
          this.pageRouterData =
            edit.pageLimit == null ? [] : JSON.parse(edit.pageLimit);
          this.loading = false;
        });
      } else {
        this.formData = {
          name: "",
          des: "",
          rule_ids: ""
        };
      }
    },
    //保存表单
    save() {
      var ids = this.$refs.tree.getCheckedKeys();
      console.log(ids);
      // return false;
      this.$refs.formData.validate(valid => {
        if (valid) {
          var data = Object.assign({}, this.formData);
          // data.rule_ids = this.selected.join(',');
          data.token = this.token;
          data.app_id = this.app_id;
          data.rule_ids = ids.join(",");
          data.pageLimit = JSON.stringify(this.pageRouterData);
          console.log(data);
          if (this.if_add) {
            //新增
            // 先验证手机号是否注册过
            roleAdd(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "保存成功"
                });
                this.goback();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
            });
          } else {
            //修改
            roleEdit(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "保存成功"
                });
                this.goback();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
            });
          }
        }
      });
    },
    goback() {
      this.$router.go(-1);
    },
    UpNumber(e) {
      e.target.value = e.target.value.replace(/[\W]/g, "");
    }
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 27px;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    .input_box {
      width: 400px;
    }
    .tips {
      color: #888;
    }
    .input_box_small {
      width: 202px;
    }
    .state_text {
      color: #999;
      font-size: 12px;
      height: 20px;
      line-height: 30px;
    }
    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;
      .ml30 {
        margin-left: 30px;
      }
    }
    .typeList {
      .type_name {
        font-weight: bold;
      }
    }
    .selection {
      display: block;
    }
  }
}
</style>
